import React from 'react'
import { SummaryCell } from './SummaryCell'

export function CurrencyCell ({ currency }) {
  return <SummaryCell topContent={currency} className={`align-bottom border-left`}/>
}
